import { SkillFormat } from "src/components/shared-components/enum/enumSkillFormat";
import {
  AddressDetails,
  AddressFunctionDetails,
} from "./smart-component-property";
import { SmartComponentSkillValorization } from "./smart-component-skill-valorization";
import { SmartComponentType } from "../../enum/enumSmartComponentType";

/**
 * Additional data about the valorization of a Skill of a SmartComponent.
 * This model-class is used to host the resulting data from the fetching of a specific Skill (included its current valorization) of a precise instance of SmartComponent
 */
export class SmartComponentPropertyDetails extends SmartComponentSkillValorization {
  public idSmartComponentSkill: number = 0;
  public template: string = "";
  public address: AddressDetails = null;
  public addressFunction: AddressFunctionDetails = null;
  public isAddressFunction: boolean = false;

  constructor(controlType?: any) {
    super();

    // used for assign type to instance of object
    if (controlType) {
      Object.assign(this, controlType);
    }
  }
}

export class SmartComponentSummaryData {
  public summary: boolean = false;
  public idSmartComponentKind: SmartComponentType = SmartComponentType.UNKNOWN;
  public idEnvironment: number = null;

  constructor(controlType?: any) {
    // used for assign type to instance of object
    if (controlType) {
      Object.assign(this, controlType);
    }
  }
}
